import { useMemo } from "react";
import { ICompany } from "../../models/ICompany";
import { useHprService } from "../../context/HprServiceContext";
import { HprCacheKeys } from "../cacheKeys";
import useSWR, { ConfigInterface } from "swr";

export type IUseCompanyListHook = (config?: ConfigInterface<ICompany[]>) => {
    data: ICompany[];
    fetching: boolean;
};

export const useCompanyList: IUseCompanyListHook = (config) => {
    const service = useHprService();
    const token = service.getToken();

    const fetcher = async (): Promise<ICompany[]> => {
        const companiesData = await service.getCompanies();
        if (companiesData.isFailure) {
            throw companiesData.error;
        }
        return companiesData.value;
    };

    const { data, isValidating } = useSWR(() =>
        HprCacheKeys.CompanyList(token),
        fetcher,
        {
            suspense: true,
            revalidateOnFocus: false,
            revalidateOnMount: false,
            revalidateOnReconnect: false,
            initialData: config?.initialData
        }
    );

    const rawData = data || [];


    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
    }), [rawData, isValidating]);

};